const platformPrefix = 'corelia'

export const localStorageKeys = {
  accordions: `${platformPrefix}:accordions`,
  agentMode: `${platformPrefix}:agentMode`,
  contentCountry: `${platformPrefix}:contentCountry`,
  originalUrl: `${platformPrefix}:originalUrl`,
  panels: `${platformPrefix}:panels`,
  preferredLanguage: `${platformPrefix}:preferredLanguage`,
  researchMode: `${platformPrefix}:researchMode`,
  serviceMessages: `${platformPrefix}:serviceMessages`,
}
